<template>
  <div>
    <div class="mainC " style="background: #141416; color: lightgrey;">
      <h5>{{ type.toUpperCase() }} {{ $t('LanguageEn.ranking') }}</h5>
      <div class="">
        <div class="" style="height: 12px !important; background: #141416 !important;"></div>
        <li v-if="leaderList.length<1" class="list-group-item listHeader"
            style="border-radius: 0; background: #212225; font-size: 12px; color: #E6E6E6; height: 40px;">
          <img style="margin-bottom: 3px;" src="@/assets/noInfo.svg"/>
          {{ $t('LanguageEn.noInfoa') }}
        </li>
        <div v-else>
          <li class="container"
              style="color: #E6E6E6; background: #212225; height: 34px; line-height: 34px !important; list-style-type: none; font-size: 12px;">
            <div class="row">
              <div class="col-2 pr-0" style="text-align: center;">
                #
              </div>
              <div class="col">
                {{ $t('LanguageEn.team') }}
              </div>
              <div class="col-2">
                {{ $t('LanguageEn.points') }}
              </div>
              <div v-if="type === 'uefa'" class="col">
                {{ $t('LanguageEn.Coeffiecient') }}
              </div>
            </div>
          </li>
          <li v-for="(some, i) in leaderList" :key="i"
              style="height: 40px; border: none; font-size: 12px; background: #141416; padding-left: 15px;"
              class="container list-group-item">
            <div class="row">
              <div class="col-2 pr-0" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31; text-align: center;">
                {{ some.position }}
                <img v-if="some.positionStatus === 'up'" src="@/assets/up.png"
                     style="width: 15px; margin-bottom: 3px; margin-left: 2px;" alt="">
                <img v-else-if="some.positionStatus === 'down'" src="@/assets/down.png"
                     style="width: 15px; margin-bottom: 3px; margin-left: 2px;" alt="">
                <img v-else-if="some.positionStatus === 'equal'" src="@/assets/dash.png"
                     style="width: 15px; margin-bottom: 3px; margin-left: 2px;" alt="">
              </div>
              <div class="col " style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                <img :src="teamLogo + some.team.id" alt="" style="width: 20px; padding-bottom: 5px;">
                <router-link id="" style="text-decoration: none; color: #E6E6E6;"
                             :to="{ name: 'teamPage', params: { id: some.team.id } }">
                  <span class="MobileHide">{{ some.team.name }}</span><span class="MobileShow"
                                                                            style="margin-left: 4px;"><span
                    v-if="some.team.shortCode">{{ some.team.shortCode }}</span><span
                    v-else>{{ some.team.name.slice(0, 3).toUpperCase() }}</span></span>
                </router-link>
              </div>
              <div class="col-2" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                {{ some.points }}
              </div>
              <div v-if="type === 'uefa'" class="col" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                {{ some.coeffiecient }}
              </div>
            </div>
          </li>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {API_BASE_URL} from "@/repository/repository";
import {mapGetters} from "vuex";

export default {
  name: 'Ranks',
  data() {
    return {
      type: '',
      leaderList: '',
      tabIndex: 0,
      teamLogo: API_BASE_URL+'/team/logo/',
      id: '',
    }
  },
  async mounted() {
    this.type = this.$route.params.type;

    this.getList();

  },

  components: {},
  props: {},
  methods: {
    getList() {

      fetch(API_BASE_URL + "/team/rankings?rankingType=" + this.type + "&token=" + this.token, {
        method: 'GET',
        redirect: 'follow'
      })
          .then(response => response.json())
          .then(result => {
            if (result.code === 200) {
              this.leaderList = result.teamRankings;
            }
          })
          .catch(error => console.log('error', error));
    }
  },

  computed: {
    ...mapGetters(["token"])
  },

}

</script>

<style scoped>
@media only screen and (max-width: 770px) {
  body {
    background: #212529;
  }

  .navDiv2 {
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;
  }

  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 992px) {
  .MobileShow {
    display: none;
  }

}

</style>
